import { RouterProvider } from 'react-router-dom';
import { useEffect } from "react";
import { initSentry, Sentry } from "./utils/sentry";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { router } from './router';
import { AuthProvider } from './contexts/AuthContext';

import "./styles/index.css";

// Create QueryClient once at module level
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    },
  },
});

const App = () => {
    // Initialize Sentry on client side
    useEffect(() => {
        initSentry();
    }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
      <Sentry.ErrorBoundary
          fallback={({ error, resetError }) => (
              <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
                  <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
                      <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
                          <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                          </svg>
                      </div>
                      <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100 text-center mb-2">
                          Une erreur est survenue
                      </h1>
                      <p className="text-gray-600 dark:text-gray-400 text-center mb-4">
                          L&apos;application a rencontré un problème inattendu. Nos équipes ont été notifiées.
                      </p>
                      {import.meta.env.DEV && (
                          <pre className="bg-gray-100 dark:bg-gray-700 p-4 rounded text-xs overflow-auto mb-4 text-left">
                    {error instanceof Error ? error.toString() : String(error)}
                  </pre>
                      )}
                      <button
                          onClick={resetError}
                          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors"
                      >
                          Réessayer
                      </button>
                  </div>
              </div>
          )}
      >
        <RouterProvider router={router} />
      </Sentry.ErrorBoundary>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
